<div class="tile">
  <div class="header">
    <h4 class="company-name">{{ authStore.companyName$ | async }}</h4>
    <div class="badge">
      <app-booking-package-badge
        [packageType]="subscription.plan"
        size="small"
      ></app-booking-package-badge>
    </div>
  </div>
  <p class="row-data" *ngIf="authStore.companyAddressAsString$ | async as address">{{ address }}</p>
  <p class="row-data">
    {{ dateLabel | translate }}
    {{ subscription.expirationDate | date }}
  </p>
  <p class="row-data">
    {{ '+BOOKING.OVERVIEW.COMMERCIAL.BOOKING_FROM' | translate }}
    {{ subscription.subscribedByName }}
  </p>
</div>
